export default "__VITE_ASSET__Bg4Le9f3__"